import { ExternalResources } from "@constants";
import Paragraph from "@components/Placeholder/Paragraph.vue";
import SearchModal from "@public-client/Components/SearchModal/SearchModal.vue";
import ExpandingDataCard from "@public-client/Components/ExpandingDataCard.vue";
export default {
  components: {
    SearchModal,
    Paragraph,
    ExpandingDataCard
  },
  data() {
    return {
      ExternalResources: ExternalResources.IEPP
    };
  },
  mounted() {
    if (this.$route.query.scrollTo) {
      let target = document.querySelector(this.$route.query.scrollTo);
      if (target) setTimeout(() => target.scrollIntoView({
        behavior: "smooth"
      }), 700);
    }
  },
  computed: {
    domains() {
      return this.$store.state.domains;
    }
  }
};